export default {
  address: {
    line1: "2828 boulevard Laurier, suite 700",
    line2: "Québec, QC G1V 0B9",
    country: "Canadá",
  },
  seo: {
    title: "Consultants Succès Inc | Financiamiento empresarial en Quebec",
    description: "Financiamiento empresarial en Quebec desde 2016: capital de trabajo, tarjetas de crédito corporativas y financiamiento de proyectos inmobiliarios. Consultants Succès Inc — Vladimir Blain, consultor principal.",
  },
  nav: {
    services: "Servicios",
    solutions: "Soluciones",
    approche: "Método",
    consultant: "Consultor",
    faq: "FAQ",
    contact: "Contacto",
    vytali: "Descubrir Vytali",
    apply: "Iniciar una solicitud",
    portal: "Acceder a mi espacio",
    impact: "Impacto social",
    ariaMenu: "Menú",
    ariaChangeLang: "Cambiar idioma",
  },
  impactHome: {
    eyebrow: "Impacto social",
    title: "El éxito que genera impacto",
    text: "Además de nuestras actividades de financiamiento y acompañamiento a emprendedores, Consultants Succès también participa en determinadas iniciativas sociales, comunitarias y benéficas junto a socios comprometidos.",
    cta: "Descubrir nuestro impacto social",
  },
  impact: {
    seoTitle: "Impacto social | Consultants Succès",
    seoDesc: "Descubra el compromiso social y comunitario de Consultants Succès y las iniciativas en las que participamos junto a socios comprometidos.",
    heroTitle: "El éxito cobra aún más sentido cuando también contribuye a los demás.",
    heroSubtitle: "Consultants Succès participa en distintas iniciativas sociales, comunitarias y benéficas para generar un impacto positivo en las comunidades donde estamos presentes.",
    heroCta1: "Descubrir nuestras iniciativas",
    heroCta2: "Contáctenos",
    engagementTitle: "Nuestro compromiso",
    engagementParas: [
      "En Consultants Succès creemos que el crecimiento económico y el impacto humano positivo pueden avanzar juntos.",
      "Nuestra actividad principal sigue enfocada en el acompañamiento a emprendedores, el financiamiento empresarial y el financiamiento de proyectos.",
      "Al mismo tiempo, participamos en determinadas iniciativas sociales, comunitarias y benéficas junto a socios comprometidos.",
      "Nuestro objetivo es contribuir a generar resultados positivos más allá de los negocios.",
    ],
    howTitle: "Cómo contribuimos",
    howItems: [
      { title: "Iniciativas comunitarias", text: "Participación en iniciativas destinadas a apoyar y movilizar a las comunidades." },
      { title: "Campañas benéficas", text: "Colaboración en determinadas campañas benéficas junto a socios y organizaciones comprometidas." },
      { title: "Movilización de socios", text: "Creación de puentes entre empresas, socios e iniciativas con impacto positivo." },
      { title: "Eventos y sensibilización", text: "Participación en eventos y acciones para sensibilizar, movilizar y unir." },
    ],
    initiativesTitle: "Nuestras iniciativas",
    initiativesCardTitle: "Iniciativas que evolucionan con nuestro compromiso",
    initiativesCardText: "Consultants Succès participa y seguirá colaborando en distintas iniciativas sociales y comunitarias. Las campañas y proyectos aprobados para comunicación pública se presentarán aquí progresivamente.",
    participateItems: [
      { title: "Participar", text: "Descubra las iniciativas y actividades en las que participa Consultants Succès." },
      { title: "Colaborar", text: "Empresas, socios y organizaciones pueden comunicarse con nosotros para explorar posibles colaboraciones." },
      { title: "Apoyar", text: "Cuando determinadas campañas lo permitan, las modalidades de participación o apoyo se indicarán claramente." },
    ],
    transparencyTitle: "Un enfoque transparente",
    transparencyParas: [
      "Consultants Succès puede participar en campañas, eventos o iniciativas en colaboración con distintos socios u organizaciones. Cuando una iniciativa incluya donaciones o contribuciones financieras, las modalidades aplicables y la organización beneficiaria deberán identificarse claramente.",
      "Consultants Succès no es una organización benéfica registrada.",
    ],
  },
  hero: {
    kicker: "Financiamiento empresarial — Quebec, desde 2016",
    lines: ["El capital necesario,", "en el momento en que", "más importa."],
    subtitle: "Capital de trabajo, crédito empresarial y proyectos inmobiliarios. Consultants Succès Inc acompaña a los emprendedores de Quebec hacia el financiamiento que impulsa sus proyectos.",
    primaryCta: "Planificar mi estrategia de financiamiento",
    vytaliCta: "Descubrir Vytali",
  },
  trust: {
    tagline: "Más soluciones. Más posibilidades.",
    taglineGold: "Más crecimiento.",
    items: [
      { title: "Red de prestamistas especializados", desc: "Acceda a varias soluciones de financiamiento adaptadas a su empresa." },
      { title: "Análisis rápido de expedientes", desc: "Analizamos su solicitud para identificar las mejores opciones disponibles." },
      { title: "Acompañamiento personalizado", desc: "Un asesor lo acompaña en cada etapa hasta obtener su financiamiento." },
    ],
  },
  stats: {
    heading: "Una década de resultados",
    headingGold: "medibles",
    sub: "«Novato del año» en 2017, un año después de nuestra fundación. Desde entonces, nunca hemos bajado el ritmo.",
    labels: ["Fundación en marzo", "Gerentes promovidos", "Premios ganados en la Gala", "Empleados capacitados"],
  },
  marquee: {
    items: ["CONSULTANTS SUCCÈS INC", "FINANCIAMIENTO", "ESTRATEGIA", "RESULTADOS", "QUEBEC", "DESDE 2016"],
  },
  services: {
    kicker: "Nuestros servicios",
    heading: "Tres palancas para financiar su ambición",
    discuss: "Conversemos",
    items: [
      { title: "Financiamiento empresarial", desc: "Obtenga el capital de trabajo necesario para estabilizar sus operaciones, aprovechar oportunidades y sostener su crecimiento sin comprometer su liquidez." },
      { title: "Tarjetas de crédito", desc: "Una línea de crédito establecida a nombre de su empresa — no al suyo. Construya su crédito empresarial y separe sus finanzas personales de las de su compañía." },
      { title: "Proyectos inmobiliarios", desc: "Financiamiento estructurado para la adquisición de inmuebles y la realización de múltiples proyectos. Desde la primera propiedad hasta un portafolio completo." },
    ],
  },
  solutions: {
    kicker: "Nuestras soluciones de financiamiento",
    heading: "Una oferta completa, adaptada a",
    headingGold: "su realidad",
    request: "Solicitar financiamiento",
    items: [
      { title: "Capital de trabajo", desc: "Capital rápido para sostener sus operaciones diarias y aprovechar las oportunidades sin esperar." },
      { title: "Financiamiento de equipos", desc: "Adquiera la maquinaria y los equipos que su crecimiento requiere sin inmovilizar su liquidez." },
      { title: "Financiamiento de facturas", desc: "Convierta sus cuentas por cobrar en liquidez inmediata en lugar de esperar 30, 60 o 90 días." },
      { title: "Bienes raíces comerciales", desc: "Financiamiento estructurado para la adquisición, conversión o desarrollo de propiedades comerciales." },
      { title: "Crédito empresarial", desc: "Construya el crédito de su empresa con tarjetas y líneas de crédito a su nombre, no al suyo." },
      { title: "Crecimiento y expansión", desc: "Capital estructurado para abrir una nueva ubicación, contratar personal o conquistar nuevos mercados." },
    ],
  },
  etapes: {
    kicker: "Nuestro método",
    heading: "Cuatro etapas.",
    headingGold: "Un método probado.",
    steps: [
      { title: "Estudio del mercado", desc: "Analizamos su sector, sus competidores y su posicionamiento para identificar las oportunidades de financiamiento más ventajosas." },
      { title: "Informar al cliente", desc: "Una comunicación clara y transparente: usted comprende cada opción y cada condición antes de tomar una decisión." },
      { title: "Vender", desc: "Presentamos su expediente de la mejor manera ante las instituciones adecuadas, para maximizar sus probabilidades de aprobación." },
      { title: "Fidelizar", desc: "La relación no termina con la aprobación. Seguimos a su lado para sus próximos proyectos y su crecimiento a largo plazo." },
    ],
  },
  consultant: {
    kicker: "Consultor principal",
    role: "Consultor principal",
    heading: "Vladimir Blain, el aliado de los emprendedores que piensan en grande",
    p1: "Al frente de Consultants Succès desde marzo de 2016, Vladimir Blain ha construido un equipo reconocido — «Novato del año» desde 2017, seis premios en la Gala, cinco gerentes promovidos y más de treinta empleados capacitados. Su convicción: toda empresa merece un acceso claro y rápido al capital que la hará crecer.",
    p2Before: "Hoy conecta el financiamiento con el crecimiento dirigiendo también ",
    p2Brand: "Vytali Marketing",
    p2After: " — la plataforma que ayuda a las empresas de Quebec a generar y convertir más clientes.",
    promoBefore: "Impulsado por ",
    promoBrand: "Vytali",
    promoAfter: ", nuestra plataforma de inteligencia comercial, para análisis más rápidos y respuestas más precisas a sus solicitudes de financiamiento.",
    vytaliCta: "Descubrir Vytali",
    writeCta: "Escribir al equipo",
    photoAlt: "Vladimir Blain, consultor principal",
  },
  calc: {
    eyebrow: "Calculadora de financiamiento",
    title: "Estime sus pagos.",
    desc: "Explore diferentes escenarios de financiamiento con fines informativos.",
    amountLabel: "Monto del financiamiento",
    termLabel: "Plazo",
    termUnit: "meses",
    rateLabel: "Tasa anual estimada",
    rateHelp: "Utilice una tasa estimada para explorar distintos escenarios. La tasa real dependerá del producto, del prestamista, de la elegibilidad y de las condiciones aplicables.",
    illustrative: "Escenario ilustrativo — ajuste los valores según su situación.",
    resultTitle: "Pago mensual estimado",
    perMonth: "/ mes",
    sumAmount: "Monto",
    sumTerm: "Plazo",
    sumRate: "Tasa estimada",
    disclaimer: "Esta simulación se ofrece únicamente con fines informativos. No constituye una oferta de financiamiento ni una aprobación. Las tasas, pagos y condiciones reales pueden variar según el producto, el prestamista, la elegibilidad y las condiciones aplicables.",
    cta: "Solicitar una evaluación personalizada",
    contactMessage: "Me gustaría hablar sobre el escenario de financiamiento que acabo de simular.",
    errAmount: "Ingrese un monto mayor que 0.",
    errTerm: "Ingrese un plazo en meses entre 1 y 600.",
    errRate: "Ingrese una tasa entre 0 y 100.",
  },
  faq: {
    kicker: "FAQ",
    heading: "Sus preguntas sobre el",
    headingGold: "financiamiento",
    sub: "Capital de trabajo, crédito empresarial, bienes raíces — respuestas a las preguntas que más nos hacen.",
    items: [
      { q: "¿Qué es el capital de trabajo y para qué sirve?", a: "El capital de trabajo es el dinero del que dispone su empresa para cubrir sus operaciones corrientes: inventario, salarios, proveedores, marketing. Un financiamiento de capital de trabajo le permite aprovechar oportunidades y atravesar los períodos lentos sin comprometer su liquidez." },
      { q: "¿Cuál es la diferencia entre una tarjeta de crédito personal y una empresarial?", a: "Una tarjeta empresarial se establece a nombre de su empresa, no al suyo. Construye el historial de crédito de su compañía, separa sus finanzas personales de las del negocio y protege su puntaje de crédito personal. Es un paso esencial para acceder después a financiamientos más importantes." },
      { q: "Mi empresa es joven — ¿puedo obtener financiamiento de todos modos?", a: "Sí. Nuestro rol es precisamente estructurar su expediente para presentarlo de la mejor manera ante las instituciones adecuadas. Cada situación es única: escríbanos y evaluaremos juntos las opciones adaptadas a su etapa de crecimiento." },
      { q: "¿Financian proyectos inmobiliarios?", a: "Por supuesto. Acompañamos la adquisición de inmuebles y la realización de múltiples proyectos — desde la primera propiedad hasta un portafolio completo. Estructuramos el financiamiento según la naturaleza del proyecto: adquisición, conversión o desarrollo." },
      { q: "¿Cuánto tiempo toma el proceso?", a: "Depende del tipo de financiamiento y de la preparación de su expediente. Nuestro método de 4 etapas (estudio, información, presentación, seguimiento) busca acelerar cada fase. Contáctenos para una evaluación inicial rápida de su situación." },
      { q: "¿Sus servicios se limitan a la región de Quebec?", a: "Nuestra oficina está en la ciudad de Quebec (2828 boulevard Laurier, suite 700), pero acompañamos a emprendedores en todo Quebec. La mayoría de los trámites pueden hacerse a distancia: +1 581-333-3447." },
    ],
  },
  contact: {
    kicker: "Contacto",
    heading: "Hablemos de su proyecto",
    sub: "¿Una pregunta sobre financiamiento, tarjetas de crédito empresariales o un proyecto inmobiliario? Escríbanos — un miembro del equipo le responderá rápidamente.",
    nameLabel: "Nombre completo",
    namePh: "Su nombre",
    phoneLabel: "Teléfono",
    phonePh: "Ej.: 514-555-1234",
    emailLabel: "Correo electrónico",
    emailPh: "usted@empresa.com",
    solutionLabel: "Solución de interés",
    solutionOptional: "(opcional)",
    solutionPh: "Ej.: Capital de trabajo, Bienes raíces comerciales…",
    solutionSelectPh: "Seleccione una solución…",
    messageLabel: "Su pregunta",
    messagePh: "Describa su proyecto o haga su pregunta…",
    submit: "Enviar mi pregunta",
    sending: "Enviando…",
    fillAll: "Por favor complete todos los campos.",
    errName: "Por favor ingrese su nombre completo.",
    errEmail: "Por favor ingrese una dirección de correo válida.",
    errPhone: "Por favor ingrese un número de teléfono válido.",
    success: "¡Mensaje enviado! Le responderemos muy pronto.",
    error: "Ocurrió un error. Por favor intente de nuevo.",
    rateLimited: "Demasiados mensajes enviados. Intente de nuevo en unos minutos.",
    mapTitle: "Oficina de Consultants Succès — 2828 boulevard Laurier, Québec",
    mapLink: "Cómo llegar en Google Maps",
    consentNote: "Al enviar este formulario, usted solicita ser contactado por Consultants Succès Inc con respecto a su solicitud. Sus datos de contacto se utilizan únicamente para este seguimiento.",
  },
  footer: {
    desc: "El socio financiero de las empresas de Quebec: financiamiento empresarial, crédito corporativo y proyectos inmobiliarios. Fundada en marzo de 2016.",
    coordinates: "Datos de contacto",
    follow: "Síganos",
    vytali: "Descubrir Vytali",
    rights: "Todos los derechos reservados.",
    role: "Vladimir Blain — Consultor principal",
  },
  call: {
    main: "Oficina principal",
    quebec: "Oficina de Quebec",
    ariaOpen: "Llamar a Consultants Succès",
    ariaClose: "Cerrar el menú de llamada",
  },
};
